import { render, staticRenderFns } from "./admissionplan.vue?vue&type=template&id=0792b8f9&scoped=true&"
import script from "./admissionplan.vue?vue&type=script&lang=js&"
export * from "./admissionplan.vue?vue&type=script&lang=js&"
import style0 from "./admissionplan.vue?vue&type=style&index=0&id=0792b8f9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0792b8f9",
  null
  
)

export default component.exports